import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge only knows Tailwind's built-in scale names. These are the project's own names
// (tailwind.config.ts): the named z-index layers and the 8px control radius. Listing them here
// lets a caller's z-* or rounded-* class replace a component's default instead of both landing
// in the class list, where the stylesheet order would decide.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      z: [{ z: ["sticky", "header", "bottom", "overlay", "modal", "toast", "gate"] }],
    },
    theme: {
      borderRadius: ["control"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
